import React from 'react';
import history from '../../history';
import Link from '../../components/Link';
import MapDialog from './MapDialog';
import SecretCounter from './secretCounter';
import { Trans } from 'react-i18next';
import KeyboardArrowLeft from 'material-ui-icons/KeyboardArrowLeft';
import KeyboardArrowRight from 'material-ui-icons/KeyboardArrowRight';
import AdsDialog from './Ads';

function goEntre() {
  history.push('/entre');
  goClose();
}

function goMaisonsHote() {
  history.push('/MaisonsHote');
  goClose();
}

function goMosquee() {
  history.push('/Mosquee');
  goClose();
}

function goMaison() {
  history.push('/Maison');
  goClose();
}

function goDaraelfeija() {
  history.push('/Daraelfeija');
  goClose();
}

function goZaouia() {
  history.push('/Zaouia');
  goClose();
}

function goPaysage() {
  history.push('/Paysage');
  goClose();
}

function goClose() {
  var divsToHide = document.getElementsByClassName('hidelist');
  for (var Hide = 0; Hide < divsToHide.length; Hide++) {
    divsToHide[Hide].style.display = 'none';
  }

  document.getElementById('textheade').classList.remove('hidden');
  document.getElementById('clsicon').classList.add('hidden');
  document.getElementById('plsicon').classList.remove('hidden');
}

function gopls() {
  var divsToShow = document.getElementsByClassName('hidelist');
  for (var pls = 0; pls < divsToShow.length; pls++) {
    divsToShow[pls].style.display = 'block';
  }
  document.getElementById('textheade').classList.add('hidden');
  document.getElementById('clsicon').classList.remove('hidden');
  document.getElementById('plsicon').classList.add('hidden');
}

function handlenext() {
  var currenturl = document.querySelectorAll('[data-active]')[0].nextSibling
    .nextSibling;
  var idnext = currenturl.getAttribute('id');
  history.push('/' + idnext);
  goClose();
}

function handleprev() {
  var currenturlprev = document.querySelectorAll('[data-active]')[0]
    .previousSibling.previousSibling;
  var idnextprev = currenturlprev.getAttribute('id');
  history.push('/' + idnextprev);
  goClose();
}

function menuNav() {
  var nav = document.getElementById('listmenu'),
    anchor = nav.getElementsByTagName('li'),
    current = window.location.pathname.split('/')[1];
  for (var i = 0; i < anchor.length; i++) {
    if (anchor[i].id === current) {
      anchor[i].classList.add('current');
      anchor[i].setAttribute('data-active', 'active');
    }
    if (anchor[i].id !== current) {
      anchor[i].classList.remove('current');
      anchor[i].removeAttribute('data-active');
    }
  }
  var idactive = (current = window.location.pathname.split('/')[1]);
  if (idactive === 'Paysage') {
    document.getElementById('nextbtn').classList.add('hidden');
  } else {
    document.getElementById('nextbtn').classList.remove('hidden');
  }
  //previos
  if (idactive === 'entre') {
    document.getElementById('prevbtn').classList.add('hidden');
  } else {
    document.getElementById('prevbtn').classList.remove('hidden');
  }
}
function onHover() {
  document.getElementById('prevbtntext').className = '';
}
function onHoverr() {
  document.getElementById('nextbtntext').className = '';
}
function MouseOut() {
  document.getElementById('prevbtntext').className = 'hidden';
}

function MouseOutt() {
  document.getElementById('nextbtntext').className = 'hidden';
}

function stepper() {
  var menutab = [
      'entre',
      'MaisonsHote',
      'Mosquee',
      'Maison',
      'Daraelfeija',
      'Zaouia',
      'Paysage',
    ],
    current = window.location.pathname.split('/')[1];
  current = window.location.pathname.split('/')[1];
  if (menutab[0] === current) {
    document.getElementById('curtextact').innerHTML = 'ENTRÉE';
    document.getElementById('textheade').className = 'entreicon current';
    document.getElementById('nextbtntext').innerHTML = "MAISON D'HÔTE";
  }

  if (menutab[1] === current) {
    document.getElementById('curtextact').innerHTML = "MAISON D'HÔTE";
    document.getElementById('textheade').className = 'maisonicon current';
    document.getElementById('prevbtntext').innerHTML = 'ENTRÉE';
    document.getElementById('nextbtntext').innerHTML = 'MOSQUÉE';
  }
  if (menutab[2] === current) {
    document.getElementById('curtextact').innerHTML = 'MOSQUÉE';
    document.getElementById('textheade').className = 'mosquicon current';
    document.getElementById('prevbtntext').innerHTML = "MAISON D'HÔTE";
    document.getElementById('nextbtntext').innerHTML = 'MAISON';
  }
  if (menutab[3] === current) {
    document.getElementById('curtextact').innerHTML = 'MAISON';
    document.getElementById('textheade').className = 'soukicon current';
    document.getElementById('prevbtntext').innerHTML = 'MOSQUÉE';
    document.getElementById('nextbtntext').innerHTML = 'DAR EL FEJA';
  }
  if (menutab[4] === current) {
    document.getElementById('curtextact').innerHTML = 'DAR EL FEJA';
    document.getElementById('textheade').className = 'daraelfeija current';
    document.getElementById('prevbtntext').innerHTML = 'MAISON';
    document.getElementById('nextbtntext').innerHTML = 'ZAOUÏA';
  }
  if (menutab[5] === current) {
    document.getElementById('curtextact').innerHTML = 'ZAOUÏA';
    document.getElementById('textheade').className = 'zaouiaicon current';
    document.getElementById('prevbtntext').innerHTML = 'DAR EL FEJA';
    document.getElementById('nextbtntext').innerHTML = 'PAYSAGE';
  }
  if (menutab[6] === current) {
    document.getElementById('curtextact').innerHTML = 'PAYSAGE';
    document.getElementById('textheade').className = 'payicon current';
    document.getElementById('prevbtntext').innerHTML = 'ZAOUÏA';
  }
}

class googleMap extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hidden: 'hidden',
    };
  }

  componentDidMount() {
    menuNav();
    stepper();
  }

  componentDidUpdate() {
    menuNav();
    stepper();
  }

  render() {
    return (
      <div>
        <div className="secretdiv">
          <SecretCounter />
        </div>
        <div
          style={{
            position: `absolute`,
            bottom: `20px`,
            right: `10px`,
            color: `#fff`,
            width: `120px`,
            zIndex: `1`,
          }}
        >
          <span
            id="prevbtn"
            onClick={handleprev}
            onMouseOver={onHover}
            onMouseOut={MouseOut}
          >
            <KeyboardArrowLeft className="arrownav" />
          </span>
          <span
            id="prevbtntext"
            className="hidden"
            style={{
              position: `absolute`,
              top: `65px`,
              left: `0`,
              fontSize: `12px`,
            }}
          >
            -
          </span>

          <span
            id="nextbtn"
            onClick={handlenext}
            onMouseOver={onHoverr}
            onMouseOut={MouseOutt}
            style={{ float: `right` }}
          >
            <KeyboardArrowRight className="arrownav" />
          </span>
          <span
            id="nextbtntext"
            className="hidden"
            style={{
              position: `absolute`,
              top: `65px`,
              right: `0`,
              fontSize: `12px`,
            }}
          >
            -
          </span>
        </div>
        <ul
          style={{
            listStyle: `none`,
            position: `absolute`,
            right: `0`,
            zIndex: `8`,
            top: `50px`,
          }}
        >
          <a href="/" component={Link}>
            <li style={{ cursor: `pointer` }} className="backhomebtn">
              <a href="/" component={Link}>
                <Trans i18nKey="menu.accueil">Accueil</Trans>
              </a>
            </li>
          </a>
          <MapDialog />
          <AdsDialog />
        </ul>
        <div className="mapcont">
          <ul style={{ listStyle: `none` }} id="listmenu">
            <li id="textheade" className="entreicon current">
              <span className="btn-floating 100" />
              <span className="icontext " id="curtextact">
                -
              </span>
            </li>
            <li onClick={goEntre} id="entre" className="entreicon hidelist">
              <span className="btn-floating 100" />
              <span className="icontext">Entrée</span>
            </li>
            <span className="mappul hidelist" />
            <li
              onClick={goMaisonsHote}
              id="MaisonsHote"
              className="maisonicon hidelist"
            >
              <span className="btn-floating 101" />
              <span className="icontext">Maison d'hôte</span>
            </li>
            <span className="mappul hidelist" />
            <li onClick={goMosquee} id="Mosquee" className="mosquicon hidelist">
              <span className="btn-floating 102" />
              <span className="icontext">mosquée</span>
            </li>
            <span className="mappul hidelist" />

            <li onClick={goMaison} id="Maison" className="soukicon hidelist">
              <span className="btn-floating 103" />
              <span className="icontext">Maison</span>
            </li>

            <span className="mappul hidelist" />

            <li
              onClick={goDaraelfeija}
              id="Daraelfeija"
              className="daraelfeija hidelist"
            >
              <span className="btn-floating 103" />
              <span className="icontext">Dar el feja</span>
            </li>

            <span className="mappul hidelist" />
            <li onClick={goZaouia} id="Zaouia" className="zaouiaicon hidelist">
              <span className="btn-floating 104" />
              <span className="icontext">ZAOUÏA</span>
            </li>
            <span className="mappul hidelist" />
            <li onClick={goPaysage} id="Paysage" className="payicon hidelist">
              <span className="btn-floating 105" />
              <span className="icontext">Paysage</span>
            </li>
            <li id="clsicon" className="clsicon hidden" onClick={goClose}>
              <p className="btn-floating 106" />
              <span className="icontext" />
            </li>
            <li id="plsicon" className="plsicon " onClick={gopls}>
              <p className="btn-floating 107" />
              <span className="icontext" />
            </li>
          </ul>
        </div>
      </div>
    );
  }
}

export default googleMap;



// WEBPACK FOOTER //
// ./src/components/App/Googlemap.js